class TextBlock {
    constructor() {
        const hiddenWrappers = document.querySelectorAll('.text__block .wrap-content, .rich-text .wrap-content');
        const languageSetting = document.querySelector('[data-language]');
        const language = languageSetting ? languageSetting.getAttribute("data-language") : "sv";
        this.swedishContent = language === "sv";

        this.scrollPosition = 0;
        var self = this;

        for (var i = 0; i < hiddenWrappers.length; i++) {
            let button = document.createElement('button');
            button.innerHTML = this.swedishContent ? "Visa mer" : "Read more";
            button.classList.add('button__toggletext');
            hiddenWrappers[i].classList.add("wrap-content--closed");
            hiddenWrappers[i].parentNode.insertBefore(button, hiddenWrappers[i].nextSibling);

            button.insertAdjacentHTML('beforeend', `<svg class="icon icon__chevron">
                <use xlink:href = "/icons/sprite.svg#chevron-down" />
                </svg >`);

            let wrapper = hiddenWrappers[i];
            button.addEventListener('click', e => { this.click(e, wrapper, self); });
        }
    }

    click(e, wrapper, self) {
        e.preventDefault();

        var svg = e.currentTarget.querySelector('use');
        if (!wrapper.classList.contains('wrap-content--open')) {
            wrapper.classList.add('wrap-content--open');
            wrapper.classList.remove('wrap-content--closed');
            e.currentTarget.classList.add('button__toggletext--open');
            e.currentTarget.childNodes[0].nodeValue = this.swedishContent ? 'Visa mindre' : 'Close';
            svg.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '/icons/sprite.svg#chevron-up');
            self.scrollPosition = document.documentElement.scrollTop;
        } else {
            wrapper.classList.add('wrap-content--closed');
            wrapper.classList.remove('wrap-content--open');
            e.currentTarget.classList.remove('button__toggletext--open');
            e.currentTarget.childNodes[0].nodeValue = this.swedishContent ? 'Visa mer' : 'Show more';
            svg.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '/icons/sprite.svg#chevron-down');

            if (self.scrollPosition) {
                window.setTimeout(() => {
                    window.scroll({
                        top: self.scrollPosition,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 50);
            }
        }
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new TextBlock();
});